import { createColumnHelper } from '@tanstack/vue-table';
import { h } from 'vue'
import BasicStatus from '@/components/DataTable/BasicStatus';

const columnHelper = createColumnHelper();


function createColumn(accessor, header, size, cell = ({ getValue }) => getValue()) {
  return columnHelper.accessor(accessor, {
    header,
    cell,
    size,
  });
}


export function getUploadHistoryColumns(type) {
  let columnType = 'Yüklenen';
  switch (type) {
    case 'CREATE':
      columnType = 'Yüklenen';
      break;
    case 'UPDATE':
      columnType = 'Güncellenen';
      break;
    case 'DELETE':
      columnType = 'Silinen';
      break;
  }
  return [
    createColumn('taskSourceFile', 'Dosya', 240),
    createColumn('uploadDate', 'Yüklenme Tarihi', 150),
    createColumn('totalCount', 'Yüklenen Ürün', 120),
    createColumn('successfulCount', `Başarılı ${columnType} Ürün`, 150),
    createColumn('warningCount', 'Uyarı Alan Ürün', 130),
    createColumn('failedCount', 'Hata Alan Ürün', 120),
    createColumn(
      'taskStatus',
      'Durum',
      140,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('actionColumn', 'İşlem Sonucu', 120),
  ];
}

export function getDownloadHistoryColumns() {
  return [
    createColumn('fileName', 'Şablon', 300),
    createColumn('createdDate', 'Oluşturma Tarihi', 176),
    createColumn(
      'jobStatus',
      'Durum',
      176,
      ({ getValue }) =>
        h(BasicStatus, {
          type: getValue(),
        }),
    ),
    createColumn('jobStatus', 'İşlem', 106),
  ];
}

export function getRejectReasonColumns() {
  return [
    createColumn('productCode', 'Ürün Kodu', 200),
    createColumn('status', 'İşlem Sonucu', 150),
    createColumn('message', 'Açıklama', 920),
  ];
}
